import styled, { css } from 'styled-components';
import TooltipWrapperComponent from '@prisjakt/ui-tooltip-new';
import { Tooltip as TooltipComponent } from '@prisjakt/ui-tooltip-new/src/styles';
import { layout, media } from '@prisjakt/ui-base';
import SelectableButtonComponent from '../../../../components/selectable-button';

export const VariantGroupWrapper = styled.div`
  max-width: calc(
    100vw - ${layout.measurements.spacingSmall} -
      ${layout.measurements.spacingSmall}
  );

  ${media.mediumDown`
    max-width: 100vw;
    margin: 0 -0.4rem;
    overflow-x: auto;
  `};
`;

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;

  ${media.mediumDown`
    margin: 0;
    padding: 0;
    padding-bottom: 2px;
    flex-wrap: nowrap;

    > :first-child {
      margin-left: ${layout.measurements.spacingSmall};
    }

    &::after {
      content: '\\00a0';
      display: block;
      width: ${layout.measurements.spacingNormal};
      height: 1px;
      order: 99;
    }
  `}
`;

type TooltipProps = {
  order: number;
};

export const Tooltip = styled(TooltipWrapperComponent)<TooltipProps>(
  props => css`
    flex: 0 0 auto;
    order: ${props.order};

    ${TooltipComponent} {
      ${media.mediumDown`
        display:none;
      `};
    }
  `
);

type SelectableButtonProps = {
  selected: boolean;
};

export const SelectableButton = styled(SelectableButtonComponent)<
  SelectableButtonProps
>(
  props => css`
    display: flex;
    min-width: ${props.selected ? '80px' : '40px'};
    min-height: 40px;
    background-color: ${props.theme.buttons.category.bg};
  `
);

export const ShowMoreLessButton = styled(SelectableButtonComponent)`
  display: flex;
  min-width: 40px;
  min-height: 40px;
  justify-content: center;
  padding: 0;
`;

type ColorProps = {
  variantData: string;
  isSelected: boolean;
};

export const Color = styled.div<ColorProps>(
  props => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    min-width: 16px;
    height: 16px;
    min-height: 16px;
    border-radius: 16px;
    background: ${props.variantData};
    margin-right: ${props.isSelected ? layout.measurements.spacingSmall : 0};

    svg {
      width: 12px;
      height: 12px;
      color: ${props.theme.colors.base0};
    }

    ${props.variantData === '#FFFFFF' && // Custom styling for color white
      css`
        border: 1px solid ${props.theme.colors.base300};

        svg {
          color: ${props.theme.colors.base900};
        }
      `}
  `
);

export const ShowMoreLessInner = styled.div`
  color: ${p => p.theme.colors.maybeBlue700};
  line-height: 1;
`;

type WrapLineProps = {
  order: number;
};

export const WrapLine = styled.div<WrapLineProps>(
  props => css`
    flex: 1 0 100%;
    order: ${props.order};
  `
);
